(function ($, Promise) {

		var WEST = Math.PI * 1;
		var EAST = Math.PI * 0;

		// Constructor
		function SkillGamesGame3WindAnimation(parent) {

			this.parent = parent;

			this.frameTexturesEast = [];
			this.frameTexturesWest = [];
			this.currentFrameSet = false;

			this.counter = 0;
			this.startedAt = 0;

			// Graphic holder
			this.graphic = new PIXI.Container();

			// Load textures
			for (var i = 0; i <= 22; i++) {
				var frameTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/wind swirls-EST/01_wind-EST_000' + (i < 10 ? "0" + i.toString() : i.toString()) + '.png');
				this.frameTexturesWest.push(frameTexture);
			}

			for (var i = 3; i <= 25; i++) {
				var frameTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/wind swirls-OUEST/01_wind-OUEST_000' + (i < 10 ? "0" + i.toString() : i.toString()) + '.png');
				this.frameTexturesEast.push(frameTexture);
			}

			// Create main sprite
			this.animationSprite = new PIXI.Sprite(this.frameTexturesEast[0]);
			this.graphic.addChild(this.animationSprite)
		}


		SkillGamesGame3WindAnimation.prototype.draw = function (delta) {
			this.counter += delta * 0.1;

			if (this.currentFrameSet != false) {
				// Update texture
				var currentIndex = constrain(Math.floor((this.counter - this.startedAt) / 0.5), 0, this.currentFrameSet.length - 1);
				this.animationSprite.texture = this.currentFrameSet[currentIndex];

				// Stop animation if we are at end
				if (currentIndex == this.currentFrameSet.length - 1) {
					this.currentFrameSet = false;
				}
			}
		}


		SkillGamesGame3WindAnimation.prototype.setDirection = function (direction) {

			this.startedAt = this.counter;

			if (direction == EAST) {
				this.currentFrameSet = this.frameTexturesEast;
			} else {
				this.currentFrameSet = this.frameTexturesWest;
			}

		}


		SkillGamesGame3WindAnimation.prototype.reset = function () {
			this.animationSprite.texture = this.frameTexturesEast[0];
			this.currentFrameSet = false;
		}

		// Expose SkillGamesGame3WindAnimation
		window.SkillGamesGame3WindAnimation = SkillGamesGame3WindAnimation;
	}

)(jQuery, Promise);
